import { Box, CircularProgress } from '@mui/material';

import { useLoadingProgress } from '@/hooks/use-loading-progress';

export default function LoadingCommon() {
  const { isLoading } = useLoadingProgress();

  if (!isLoading) return null;

  return (
    <Box
      sx={(theme) => ({
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: theme.zIndex.modal + 1,
        bgcolor: 'rgba(255,255,255,0.4)',
        backdropFilter: 'blur(1px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 2,
      })}
    >
      <CircularProgress />
    </Box>
  );
}
